import { render, staticRenderFns } from "./ShipmentEstimationViewGlobal.vue?vue&type=template&id=5055b8d8"
import script from "./ShipmentEstimationViewGlobal.vue?vue&type=script&lang=js"
export * from "./ShipmentEstimationViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports